import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getApartment } from "../services/apartment";

export function useGetApartment(id: string) {
  return useQuery({
    queryKey: ["apartments", id],
    queryFn: () => getApartment(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
